import script from "./HistoryComponentBox.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryComponentBox.vue?vue&type=script&setup=true&lang=js"

import "./HistoryComponentBox.vue?vue&type=style&index=0&id=17bfd785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bfd785"]])

export default __exports__